





























































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import QuestionCard from "@/components/question/question-card.vue";
import { SaveDanxiang, AddZicai } from "@/request/common";
@Component({
  components: {
    QuestionCard,
  },
})
export default class Name extends Vue {
  @Prop()
  private type: any;
  @Prop()
  private source: any;
  @Prop()
  private ifCountResult: any; // 是否自动计算答题率
  @Prop()
  private ifSave: any; // 是否保存结果用来统计
  @Prop()
  private data: any;
  @Watch("data", { immediate: true })
  private dataChange() {
    setTimeout(() => {
      this.$forceUpdate();
    }, 200);
  }
  @Prop()
  private questionIndex: any;
  @Watch("questionIndex", { immediate: true })
  private questionIndexChange() {
    if (this.ifCountResult) {
      this.countResult();
    }
  }
  @Prop()
  private ifShowMulu: any; // 是否显示右上角目录按钮
  private ifShowMuluDialog: any = false; // 是否显示目录答题卡
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private showJiexi() {
    this.$emit("jiexi");
  }
  private select(item: any, val: any) {
    if (!this.data[this.questionIndex].ifShowEdit) {
      return;
    }
    if (item.type == "单选" || item.type == "判断") {
      item.answer = val.value;
    } else if (item.type == "多选") {
      if (!item.answer) {
        item.answer = [];
      }
      if (item.answer.length == 0) {
        item.answer.push(val.value);
      } else {
        const index = item.answer.indexOf(val.value);
        if (index == -1) {
          item.answer.push(val.value);
        } else {
          item.answer.splice(index, 1);
        }
      }
    }
    this.ifZuoda();
    this.$forceUpdate();
    if (this.ifSave) {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const d: any = {
        qt_id: this.data[this.questionIndex].question_template_id,
        unit_id:
          this.data[this.questionIndex].question_template_id + item.title,
        大类: this.data[this.questionIndex]["类别"],
        小类: item.title,
        类型: item.type,
        correct: item.correct,
        answer: item.answer,
        options: item.options,
      };
      SaveDanxiang(this, d, loading)
        .then((res: any) => {
          loading.close();
        })
        .catch(() => {
          loading.close();
        });
    }
  }
  // 计算答题情况
  private countResult() {
    let correctNum: any = 0;
    let errorNum: any = 0;
    if (
      !this.data ||
      !this.data[this.questionIndex] ||
      !this.data[this.questionIndex].data
    ) {
      return;
    }
    this.data[this.questionIndex].data.forEach((ele: any) => {
      if (ele.type == "单选" || ele.type == "判断") {
        if (
          ele.answer === ele.correct ||
          (!ele.correct &&
            ele.correct !== 0 &&
            (ele.answer || ele.answer === 0))
        ) {
          correctNum += 1;
        } else {
          errorNum += 1;
        }
      } else if (ele.type == "多选") {
        if (!ele.correct || ele.correct.length == 0) {
          if (ele.answer && ele.answer.length > 0) {
            correctNum += 1;
          } else {
            errorNum += 1;
          }
        } else {
          if (
            ele.answer.length > 0 &&
            ele.answer.length === ele.correct.length &&
            ele.answer.length === ele.correct.length &&
            ele.answer.sort().toString() === ele.correct.sort().toString()
          ) {
            correctNum += 1;
          } else {
            errorNum += 1;
          }
        }
      } else if (ele.type == "填空") {
        if (ele.answer === ele.correct) {
          correctNum += 1;
        } else {
          errorNum += 1;
        }
      }
    });
    this.data[this.questionIndex].correctNum = correctNum;
    this.data[this.questionIndex].errorNum = errorNum;
    this.$forceUpdate();
  }

  // 题目是否作答
  private ifZuoda() {
    let result: any = false;
    this.data[this.questionIndex].data.forEach((ele: any) => {
      if (
        (ele.type == "单选" || ele.type == "判断") &&
        (ele.answer || ele.answer === 0)
      ) {
        result = true;
      }
      if (ele.type == "多选" && ele.answer && ele.answer.length > 0) {
        result = true;
      }
    });
    this.$emit("changeSelect", result);
  }

  // 是否显示选中的
  private ifSelect(item: any, val: any) {
    let result: any = false;
    if (
      (item.answer || item.answer === 0) &&
      (item.type == "单选" || item.type == "判断") &&
      item.answer === val.value
    ) {
      result = true;
    } else if (item.type == "多选" && item.answer) {
      const index = item.answer.indexOf(val.value);
      if (index !== -1) {
        result = true;
      }
    }
    return result && this.data[this.questionIndex].ifShowAnswer;
  }
  // 是否显示正确答案
  private ifCorrectAnswer(items: any, item: any) {
    let correct = [];
    if (items.type == "单选" || items.type == "判断") {
      correct = [items.correct];
    } else if (items.type == "多选") {
      correct = items.correct;
    }
    const inc = correct.findIndex((i: any) => {
      return i === item.value;
    });
    return this.data[this.questionIndex].ifShowCorrect && inc != -1;
  }
  // 是否是试卷预览
  private ifYulan(items: any, item: any) {
    let correct = [];
    if (items.type == "单选" || items.type == "判断") {
      correct = [items.correct];
    } else if (items.type == "多选") {
      correct = items.correct;
    }
    const inc = correct.findIndex((i: any) => {
      return i === item.value;
    });
    return this.data[this.questionIndex].ifShowYulan && inc != -1;
  }
  // 是否答对
  private ifDadui(item: any, val: any) {
    // 是答案
    // 是正确答案
    let result: any = false;
    if (
      ((item.type == "单选" || item.type == "判断") &&
        item.answer === item.correct &&
        item.answer === val.value) ||
      (!item.correct && item.correct !== 0 && item.answer === val.value)
    ) {
      result = true;
    }
    if (item.type == "多选" && item.answer && item.answer.length > 0) {
      if (!item.correct || item.correct.length == 0) {
        // 没有正确答案的选择也为正确
        const index1 = item.answer.indexOf(val.value);
        if (index1 !== -1) {
          result = true;
        }
      } else {
        const index1 = item.answer.indexOf(val.value);
        const index2 = item.correct.indexOf(val.value);
        if (index1 !== -1 && index2 !== -1) {
          result = true;
        }
      }
    }
    return result && this.data[this.questionIndex].ifShowAnswerResult;
  }
  // 是否答错
  private ifDacuo(item: any, val: any) {
    // 是答案
    // 不是正确答案
    let result: any = false;
    if (
      (item.type == "单选" || item.type == "判断") &&
      item.answer !== item.correct &&
      item.answer === val.value &&
      !(!item.correct && item.correct !== 0)
    ) {
      result = true;
    }
    if (
      item.type == "多选" &&
      item.answer &&
      item.correct &&
      item.correct.length > 0
    ) {
      const index1 = item.answer.indexOf(val.value);
      const index2 = item.correct.indexOf(val.value);
      if (index1 !== -1 && index2 == -1) {
        result = true;
      }
    }
    return result && this.data[this.questionIndex].ifShowAnswerResult;
  }
  private showResult() {
    if (this.source == "自采") {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      let params: any = {
        question_template_id:
          this.data[this.questionIndex].question_template_id,
        名称: this.data[this.questionIndex]["名称"],
        类别: this.data[this.questionIndex]["类别"],
        pic_urls: this.data[this.questionIndex].pic_urls,
        data: this.data[this.questionIndex].data,
        是否计算: true,
      };
      params["是否计算"] = true;
      AddZicai(this, params, loading)
        .then((res: any) => {
          loading.close();
          res.ifSelect = false;
          res.ifShowEdit = false;
          res.ifShowCorrect = true;
          res.ifShowAnswer = false;
          res.ifShowAnswerBtn = false;
          res.ifShowAnswerResult = true;
          res.ifShowAnswerJiexi = false;
          this.data[this.questionIndex] = res;
          this.$forceUpdate();
          // 计算答题率
          this.countResult();
        })
        .catch(() => {
          loading.close();
        });
    } else {
      // ifShowEdit 是否可以编辑
      // ifShowCorrect 是否显示正确答案
      // ifShowAnswer 是否显示答案
      // ifShowAnswerBtn 是否显示答案按钮
      // ifShowAnswerResult 是否显示答案结果
      this.data[this.questionIndex].ifShowEdit = false;
      this.data[this.questionIndex].ifShowCorrect = true;
      this.data[this.questionIndex].ifShowAnswer = false;
      this.data[this.questionIndex].ifShowAnswerBtn = false;
      this.data[this.questionIndex].ifShowAnswerResult = true;
      // 计算答题率
      this.countResult();
      this.$emit("edit");
    }
  }
  private IndexChange(index: any) {
    this.$emit("IndexChange", index);
    this.ifShowMuluDialog = false;
  }
  private mounted() {}
}
